import React, { useEffect, useMemo, useState } from "react";
import {
  Modal,
  Card,
  Descriptions,
  Table,
  Select,
  Button,
  Space,
  Typography,
  message,
  Popconfirm,
  Empty,
  Spin,
  Input,
  Row,
  Col,
  Tag,
  Form,
} from "antd";
import {
  SendOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  BASE_URL_BEN,
  GET_GEO_ALL,
  HEADERS_EXPORT_BEN,
  POST_LOAN_DB2,
  POST_MAIN_ASSET_BY_CONTNO,
  POST_SEND_ENFORCEMENT,
} from "../../../API/apiUrls";
import axios from "axios";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import dayjs from "dayjs";

const { Text } = Typography;

const fullName = (r) =>
  `${r?.SNAM || ""}${r?.NAME1 || ""} ${r?.NAME2 || ""}`.trim() || "-";

const renderCell = (val) => {
  if (val === null || val === undefined || val === "") return "-";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
};
const formatThaiDate = (d) =>
  d && !String(d).startsWith("0001-01-01")
    ? dayjs(d).add(543, "year").format("DD/MM/YYYY")
    : "-";

// ทรัพย์ลำดับที่ 1 : ประเภททรัพย์ไม่ถูกต้อง (1 ที่ดิน / 2 อายัดเงินได้ / 3 รถนอกสัญญา / 4 รถในสัญญา / 5 ที่ดินในสัญญา)
const AssignOnceLawyerModal = ({
  open,
  onClose,
  contracts,
  lawyerOptions,
  onSuccess,
  typeAssetUse,
}) => {
  const [, , currencyFormatPoint] = CurrencyFormat();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loanInfo, setLoanInfo] = useState(null);
  const [assets, setAssets] = useState([]);
  const [receiveBy, setReceiveBy] = useState(null);
  const [distance, setDistance] = useState(null);
  const [remark, setRemark] = useState("");
  const [geoRawData, setGeoRawData] = useState();
  const [mortgageOverride, setMortgageOverride] = useState({});
  const [editingMortgage, setEditingMortgage] = useState(false);
  const [mortgageForm] = Form.useForm();
  const [contNoSearch, setContNoSearch] = useState(null);
  console.log("contracts", contracts);

  useEffect(() => {
    if (open && contracts?.CONTNO) {
      setContNoSearch(contracts.CONTNO);
      loadData(contracts.CONTNO);
    } else if (!open) {
      setLoanInfo(null);
      setAssets([]);
      setReceiveBy(undefined);
      setDistance(null);
      setRemark("");
      setMortgageOverride({});
      setEditingMortgage(false);
      setContNoSearch(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, contracts?.CONTNO]);

  useEffect(() => {
    const loadGeoData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
        });
        setGeoRawData(res.data);
      } catch (error) {
        console.error("Error loading data:", error);
        message.error(`ไม่พบข้อมูล: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    loadGeoData();
  }, []);
  console.log("geoRawData, setGeoRawData", geoRawData);

  const loadData = async (searchContNo) => {
    const contno = (searchContNo ?? contNoSearch ?? contracts.CONTNO).trim();
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    setLoading(true);
    try {
      const fetchAssets = (cno) =>
        axios.post(
          BASE_URL_BEN + POST_MAIN_ASSET_BY_CONTNO,
          { CONTNO: cno },
          { headers: HEADERS_EXPORT_BEN },
        );

      const [res1Initial, res2] = await Promise.all([
        fetchAssets(useContno),
        axios.post(
          POST_LOAN_DB2,
          { CONTNO: `'${useContno}'` },
          { headers: HEADERS_EXPORT_BEN },
        ),
      ]);

      let res1 = res1Initial;
      if (res1?.data?.success === "ไม่พบข้อมูล" && useContno !== contno) {
        res1 = await fetchAssets(contno);
      }

      if (res1?.data?.success === "ไม่พบข้อมูล") {
        setAssets([]);
      } else {
        setAssets(
          Array.isArray(res1?.data) ? res1.data : res1?.data ? [res1.data] : [],
        );
      }

      const rawLoan = res2?.data;
      if (typeof rawLoan === "string") {
        message.warning(
          rawLoan.includes("Contract No. Not Found")
            ? "ไม่พบข้อมูลสัญญาจาก LOAN_DB2"
            : rawLoan,
        );
        setLoanInfo(null);
      } else {
        setLoanInfo(
          Array.isArray(rawLoan) ? rawLoan[0] || null : rawLoan || null,
        );
      }
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async () => {
    if (editingMortgage) {
      message.error("กรุณาบันทึกข้อมูลที่ดินที่แก้ไขหรือยกเลิกก่อน !!");
      return;
    }
    if (!receiveBy) {
      message.warning("กรุณาเลือกผู้รับผิดชอบ");
      return;
    }
    console.log("receiveBy", receiveBy);

    const payload = {
      userId: parseInt(localStorage.getItem("USER_ID")),
      idJudge: contracts.idJudge,
      receiveBy,
      distance,
      remark: remark || null,
      assets: assetsPayload,
    };
    console.log("payload", payload);

    // const payload = {
    //   userId: parseInt(localStorage.getItem("USER_ID")),
    //   idJudge: 171,
    //   receiveBy,
    //   distance: 1,
    //   remark: null,
    //   assets: [
    //     {
    //       customerId: 1927,
    //       typeAsset: 5,
    //       loanId: 784,
    //       numberLand: "53767",
    //       typeLand: 1,
    //       province: "46",
    //       district: "03",
    //       subdistrict: "02",
    //       assetValue: null,
    //     },
    //   ],
    // };

    setSubmitting(true);
    try {
      await axios.post(POST_SEND_ENFORCEMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      message.success("ส่งบังคับคดีสำเร็จ");
      onSuccess?.([
        {
          key:
            contracts?.loanNewId ??
            `${contracts?.DATA_TYPE}_${contracts?.CONTNO}`,
          lawyerName: receiveBy,
        },
      ]);
      onClose(false);
    } catch (error) {
      console.error("Error sending enforcement:", error);
      message.error(`ส่งบังคับคดีไม่สำเร็จ: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const mortgage = loanInfo?.MORTGAGE;
  // GCODE "FM" = ที่ดิน, อื่น ๆ = ยานพาหนะ — คนละชุดข้อมูลในฟิลด์เดียวกัน
  const isLandMortgage = typeAssetUse === "ที่ดิน";
  // แก้ไขข้อมูลที่ดินในสัญญาได้ (frontend override ทับค่าจาก LOAN_DB2 ก่อนส่งบังคับคดี)
  const displayMortgage = mortgage
    ? { ...mortgage, ...mortgageOverride }
    : mortgage;

  // ตาม typeMap ใน SendToLawyers.js (assetColumns) : 1 โฉนด / 2 นส.3ก. / 3 ห้องชุด
  const TYPE_LAND_ID_BY_NAME = {
    โฉนด: 1,
    "นส.3ก.": 2,
    ห้องชุด: 3,
    อาคารชุด: 4,
    "นภ.1": 5,
    "อื่น ๆ": 6,
  };

  const mortgageSelectedProvince = Form.useWatch("provCode", mortgageForm);
  const mortgageSelectedDistrict = Form.useWatch("distCode", mortgageForm);

  const mortgageProvinceOptions = useMemo(() => {
    if (!geoRawData?.province) return [];
    return geoRawData.province.map((p) => ({
      label: p.provDesc,
      value: String(p.provCode),
    }));
  }, [geoRawData]);

  const mortgageDistrictOptions = useMemo(() => {
    if (!geoRawData?.district || !mortgageSelectedProvince) return [];
    return geoRawData.district
      .filter((d) => String(d.provCode) === String(mortgageSelectedProvince))
      .map((d) => ({ label: d.distDesc, value: String(d.distCode) }));
  }, [geoRawData, mortgageSelectedProvince]);

  const mortgageSubDistrictOptions = useMemo(() => {
    if (!geoRawData?.subDistrict || !mortgageSelectedDistrict) return [];
    return geoRawData.subDistrict
      .filter(
        (s) =>
          String(s.distCode) === String(mortgageSelectedDistrict) &&
          String(s.provCode) === String(mortgageSelectedProvince),
      )
      .map((s) => ({ label: s.subDistDesc, value: String(s.subDistCode) }));
  }, [geoRawData, mortgageSelectedDistrict, mortgageSelectedProvince]);

  const handleMortgageProvinceChange = () => {
    mortgageForm.setFieldsValue({
      distCode: undefined,
      subDistCode: undefined,
    });
  };

  const handleMortgageDistrictChange = () => {
    mortgageForm.setFieldsValue({ subDistCode: undefined });
  };

  const startEditMortgage = () => {
    const provDesc = displayMortgage.TYPE;
    const distDesc = displayMortgage.MODEL;
    const subDistDesc = displayMortgage.BAAB;

    const provinceObj = geoRawData?.province?.find(
      (p) => p.provDesc === provDesc,
    );
    const provCode = provinceObj ? String(provinceObj.provCode) : undefined;

    const districtObj = geoRawData?.district?.find(
      (d) => d.distDesc === distDesc && String(d.provCode) === provCode,
    );
    const distCode = districtObj ? String(districtObj.distCode) : undefined;

    const subDistrictObj = geoRawData?.subDistrict?.find(
      (s) => s.subDistDesc === subDistDesc && String(s.distCode) === distCode,
    );
    const subDistCode = subDistrictObj
      ? String(subDistrictObj.subDistCode)
      : undefined;

    mortgageForm.setFieldsValue({
      numberLand: displayMortgage.STRNO,
      engNo: displayMortgage.ENGNO,
      typeLandName: TYPE_LAND_ID_BY_NAME[displayMortgage.COLOR]
        ? displayMortgage.COLOR
        : undefined,
      provCode,
      distCode,
      subDistCode,
    });
    setEditingMortgage(true);
  };

  const handleSaveMortgage = async () => {
    try {
      const values = await mortgageForm.validateFields();
      const provinceObj = geoRawData?.province?.find(
        (p) => String(p.provCode) === String(values.provCode),
      );
      const districtObj = geoRawData?.district?.find(
        (d) =>
          String(d.distCode) === String(values.distCode) &&
          String(d.provCode) === String(values.provCode),
      );
      const subDistrictObj = geoRawData?.subDistrict?.find(
        (s) =>
          String(s.subDistCode) === String(values.subDistCode) &&
          String(s.distCode) === String(values.distCode) &&
          String(s.provCode) === String(values.provCode),
      );

      setMortgageOverride((prev) => ({
        ...prev,
        TYPE: provinceObj?.provDesc,
        MODEL: districtObj?.distDesc,
        BAAB: subDistrictObj?.subDistDesc,
        COLOR: values.typeLandName,
        STRNO: values.numberLand,
        ENGNO: values.engNo,
      }));
      setEditingMortgage(false);
      message.success("แก้ไขข้อมูลที่ดินในสัญญาสำเร็จ");
    } catch (err) {
      // validation error, keep the form open
    }
  };

  const handleCancelMortgage = () => setEditingMortgage(false);

  // mortgage.TYPE/MODEL/BAAB/DORECV เป็นชื่อจังหวัด/อำเภอ/ตำบล (ข้อความ) ต้องเทียบกับ geoRawData เพื่อแปลงเป็น id ก่อนส่ง
  // ข้อความจริงมักมีคำนำหน้า/สะกดคลาดเคลื่อน จึงต้อง normalize + fallback ด้วย Levenshtein similarity
  const normalizeText = (text) => {
    if (!text) return "";
    return text
      .replace(/^(จ\.|จังหวัด|อ\.|อำเภอ|เขต|ต\.|ตำบล|แขวง)/g, "")
      .trim()
      .replace(/[."'์]/g, "")
      .replace(/\s+/g, "")
      .toLowerCase();
  };

  const levenshteinDistance = (str1, str2) => {
    const matrix = [];
    for (let i = 0; i <= str2.length; i++) matrix[i] = [i];
    for (let j = 0; j <= str1.length; j++) matrix[0][j] = j;
    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1,
          );
        }
      }
    }
    return matrix[str2.length][str1.length];
  };

  const similarity = (s1, s2) => {
    const longer = s1.length > s2.length ? s1 : s2;
    const shorter = s1.length > s2.length ? s2 : s1;
    if (longer.length === 0) return 1.0;
    return (
      (longer.length - levenshteinDistance(longer, shorter)) / longer.length
    );
  };

  // "กทม.", "กรุงเทพ", "กรุงเทพฯ" ฯลฯ ต่างกันมากจากคำเต็ม "กรุงเทพมหานคร"
  // จน Levenshtein similarity ไม่ผ่าน threshold จึงต้อง alias ตรง ๆ ก่อน
  const BANGKOK_ALIASES = [
    "กทม",
    "กรุงเทพ",
    "กรุงเทพฯ",
    "กรุงเทพมหานคร",
    "bangkok",
    "bkk",
  ];

  const findProvinceMatch = (provinceName) => {
    if (!provinceName || !geoRawData?.province?.length) return null;
    const normalizedInput = normalizeText(provinceName);

    if (BANGKOK_ALIASES.includes(normalizedInput)) {
      return (
        geoRawData.province.find((p) =>
          normalizeText(p.provDesc).includes("กรุงเทพ"),
        ) ||
        geoRawData.province.find((p) => String(p.provCode) === "10") ||
        null
      );
    }

    let match = geoRawData.province.find((p) =>
      normalizeText(p.provDesc).includes(normalizedInput),
    );

    if (!match) {
      let bestMatch = null;
      let bestScore = 0;
      geoRawData.province.forEach((p) => {
        const score = similarity(normalizedInput, normalizeText(p.provDesc));
        if (score > bestScore && score >= 0.75) {
          bestScore = score;
          bestMatch = p;
        }
      });
      match = bestMatch;
    }

    return match || null;
  };

  const findDistrictMatch = (provinceMatch, districtName) => {
    if (!districtName || !provinceMatch || !geoRawData?.district?.length)
      return null;
    const normalizedInput = normalizeText(districtName);
    const districtsInProvince = geoRawData.district.filter(
      (d) => String(d.provCode) === String(provinceMatch.provCode),
    );

    let match = districtsInProvince.find((d) =>
      normalizeText(d.distDesc).includes(normalizedInput),
    );

    if (!match) {
      let bestMatch = null;
      let bestScore = 0;
      districtsInProvince.forEach((d) => {
        const score = similarity(normalizedInput, normalizeText(d.distDesc));
        if (score > bestScore && score >= 0.75) {
          bestScore = score;
          bestMatch = d;
        }
      });
      match = bestMatch;
    }

    return match || null;
  };

  const findSubDistrictMatch = (
    provinceMatch,
    districtMatch,
    subDistrictName,
  ) => {
    if (
      !subDistrictName ||
      !provinceMatch ||
      !districtMatch ||
      !geoRawData?.subDistrict?.length
    )
      return null;
    const normalizedInput = normalizeText(subDistrictName);
    const subDistrictsInDistrict = geoRawData.subDistrict.filter(
      (s) =>
        String(s.provCode) === String(provinceMatch.provCode) &&
        String(s.distCode) === String(districtMatch.distCode),
    );

    let match = subDistrictsInDistrict.find((s) =>
      normalizeText(s.subDistDesc).includes(normalizedInput),
    );

    if (!match) {
      let bestMatch = null;
      let bestScore = 0;
      subDistrictsInDistrict.forEach((s) => {
        const score = similarity(normalizedInput, normalizeText(s.subDistDesc));
        if (score > bestScore && score >= 0.8) {
          bestScore = score;
          bestMatch = s;
        }
      });
      match = bestMatch;
    }

    return match || null;
  };

  // ทรัพย์ลำดับที่ 1 : ประเภททรัพย์ไม่ถูกต้อง (1 ที่ดิน / 2 อายัดเงินได้ / 3 รถนอกสัญญา / 4 รถในสัญญา / 5 ที่ดินในสัญญา)
  const contractAssetPayload = useMemo(() => {
    if (!mortgage) return null;
    if (isLandMortgage) {
      const provinceMatch = findProvinceMatch(displayMortgage.TYPE);
      const districtMatch = findDistrictMatch(
        provinceMatch,
        displayMortgage.MODEL,
      );
      const subdistrictMatch = findSubDistrictMatch(
        provinceMatch,
        districtMatch,
        displayMortgage.BAAB,
      );
      return {
        customerId: contracts?.CUSTOMER_ID,
        typeAsset: 5, // ที่ดินในสัญญา
        loanId: contracts?.loanId,
        numberLand: displayMortgage.STRNO,
        typeLand: TYPE_LAND_ID_BY_NAME[displayMortgage.COLOR] ?? null,
        province: provinceMatch ? String(provinceMatch.provCode) : null,
        district: districtMatch ? String(districtMatch.distCode) : null,
        subdistrict: subdistrictMatch
          ? String(subdistrictMatch.subDistCode)
          : null,
        assetValue: null,
      };
    }
    return {
      customerId: contracts?.CUSTOMER_ID,
      typeAsset: 4, // รถในสัญญา
      loanId: contracts?.loanId,
      vhType: mortgage.TYPE,
      vhModel: mortgage.MODEL,
      vhColor: mortgage.COLOR,
      vhChassisNo: mortgage.STRNO,
      vhLicensePlate: mortgage.REGNO,
      vhRegProvince: mortgage.DORECV,
      assetValue: null,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mortgage, displayMortgage, isLandMortgage, contracts, geoRawData]);

  // จังหวัดของทรัพย์ในสัญญา (ที่ดิน: mortgage.TYPE / รถ: vhRegProvince) เอาไว้คำนวณ zoneGrade รวมกับทรัพย์ที่สืบออนไลน์พบ
  const contractAssetZoneGrade = useMemo(() => {
    if (!mortgage) return null;
    const provinceName = isLandMortgage
      ? displayMortgage.TYPE
      : mortgage.DORECV;
    return findProvinceMatch(provinceName)?.zoneGrade ?? null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mortgage, displayMortgage, isLandMortgage, geoRawData]);

  const foundAssetPayload = useMemo(
    () =>
      assets.flatMap((assetGroup) =>
        (assetGroup?.data || []).flatMap((item) =>
          (item.assetLand || []).map((land) => ({
            customerId: item.customerId,
            typeAsset: 1, // ที่ดิน (สืบออนไลน์พบ)
            assetLandId: land.landId,
            numberLand: land.numberLand,
            typeLand: land.typeLand,
            province: land.province,
            district: land.district,
            subdistrict: land.subdistrict,
            zipcode: land.zipcode,
            assetValue: land.landPrice,
          })),
        ),
      ),
    [assets],
  );

  const assetsPayload = useMemo(
    () => [contractAssetPayload, ...foundAssetPayload].filter(Boolean),
    [contractAssetPayload, foundAssetPayload],
  );

  const foundAssetRows = useMemo(
    () =>
      assets.flatMap((assetGroup) =>
        (assetGroup?.data || []).flatMap((item) => {
          const lands = item.assetLand || [];
          return lands.map((land, i) => ({
            key: `${item.assetOnlineId}-${land?.landId ?? i}`,
            fullName: fullName(item),
            relation: item.relation || (item.garno === 0 ? "ผู้กู้" : "ผู้ค้ำ"),
            LOCAT: item.LOCAT,
            typeLand: land?.typeLand,
            numberLand: land?.numberLand,
            province: land?.provDesc,
            district: land?.distDesc,
            subDistrict: land?.subDistDesc,
            landPrice: land?.landPrice,
            total: item.money?.total,
          }));
        }),
      ),
    [assets],
  );

  // เทียบจังหวัดของทรัพย์ที่พบ + ทรัพย์ในสัญญา (ที่ดิน/รถ) กับ geoRawData.province แล้วเก็บ zoneGrade สูงสุดไว้ที่ distance
  useEffect(() => {
    if (!geoRawData?.province?.length) return;

    const zoneGrades = foundAssetRows
      .map((row) =>
        geoRawData.province.find((p) => p.provDesc === row.province),
      )
      .filter(Boolean)
      .map((p) => p.zoneGrade)
      .concat(contractAssetZoneGrade)
      .filter((grade) => grade !== undefined && grade !== null);

    if (zoneGrades.length) {
      setDistance(Math.max(...zoneGrades));
    }
  }, [foundAssetRows, geoRawData, contractAssetZoneGrade]);

  const foundAssetColumns = [
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "fullName",
      key: "fullName",
      ellipsis: true,
    },
    {
      title: "ความสัมพันธ์",
      dataIndex: "relation",
      key: "relation",
      ellipsis: true,
      render: renderCell,
    },

    {
      title: "เลขที่ดิน",
      dataIndex: "numberLand",
      key: "numberLand",
      ellipsis: true,
      render: renderCell,
    },
    {
      title: "จังหวัด",
      dataIndex: "province",
      key: "province",
      ellipsis: true,
      render: renderCell,
    },
    {
      title: "อำเภอ",
      dataIndex: "district",
      key: "district",
      ellipsis: true,
      render: renderCell,
    },
    {
      title: "ตำบล",
      dataIndex: "subDistrict",
      key: "subDistrict",
      ellipsis: true,
      render: renderCell,
    },
  ];

  const caseStatusLabel =
    contracts.flagLoanNew === 1 || contracts.flagDue === 0
      ? "ทำยอม"
      : contracts.flagLoanNew === 2 || contracts.flagDue === 1
        ? "พิพากษามีดิส"
        : "พิพากษา";
  const CASE_STATUS_COLOR = {
    ทำยอม: "gold",
    พิพากษามีดิส: "blue",
    พิพากษา: "geekblue",
  };

  console.log("contracts", contracts);
  console.log("assets", assets);
  console.log("loanInfo", loanInfo);

  return (
    <Modal
      title={
        <Space>
          ส่งบังคับคดี
          <Tag color={CASE_STATUS_COLOR[caseStatusLabel]}>
            {caseStatusLabel}
          </Tag>
        </Space>
      }
      open={open}
      onCancel={() => onClose(false)}
      footer={null}
      width={800}
      destroyOnHidden
    >
      <Spin spinning={loading}>
        <Card size="small" title="รายละเอียดสัญญา" style={{ marginBottom: 16 }}>
          <Descriptions column={2} size="small" bordered>
            <Descriptions.Item label="เลขสัญญา">
              {contracts?.CONTNO}
            </Descriptions.Item>
            <Descriptions.Item label="เลขบัตรประชาชน/นิติบุคคล">
              {contracts?.CUSCOD || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="ชื่อ-นามสกุล" span={2}>
              {fullName(contracts)}
            </Descriptions.Item>
            <Descriptions.Item label="ขาดการติดต่อ/งวด">
              {contracts?.EXPREAL || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="ขาดการติดต่อ/วัน">
              {contracts?.LOSTDAY || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="เลขคดีแดง" span={2}>
              {contracts?.redCaseNumber || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="ยอดหนี้คงเหลือ">
              {currencyFormatPoint(contracts?.KARBAL) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="เบี้ยปรับ">
              {currencyFormatPoint(
                contracts?.BEEYPUP - contracts.SMPAY_BEEYPUP,
              ) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="วันทำสัญญา">
              {formatThaiDate(contracts?.SDATE) || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="วันชำระล่าสุด">
              {formatThaiDate(contracts?.LPAYD) || "-"}
            </Descriptions.Item>
          </Descriptions>
        </Card>
        <Card
          size="small"
          title={
            <Space>
              ทรัพย์ในสัญญา
              <Tag color="cyan">{typeAssetUse}</Tag>
            </Space>
          }
          extra={
            isLandMortgage && mortgage ? (
              !editingMortgage ? (
                <Button
                  size="small"
                  type="text"
                  icon={<EditOutlined />}
                  onClick={startEditMortgage}
                >
                  แก้ไข
                </Button>
              ) : (
                <Space size={4}>
                  <Button
                    size="small"
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={handleSaveMortgage}
                  >
                    บันทึก
                  </Button>
                  <Button
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={handleCancelMortgage}
                  >
                    ยกเลิก
                  </Button>
                </Space>
              )
            ) : (
              !loanInfo && (
                <Space size={5}>
                  <Input
                    value={contNoSearch}
                    onChange={(e) => setContNoSearch(e.target.value)}
                    size="small"
                  />
                  <Button
                    size="small"
                    icon={<SendOutlined />}
                    onClick={() => {
                      if (!contNoSearch?.trim()) {
                        message.warning("กรุณากรอกเลขสัญญา");
                        return;
                      }
                      loadData(contNoSearch);
                    }}
                  >
                    ค้นหา
                  </Button>
                </Space>
              )
            )
          }
          style={{ marginBottom: 16 }}
        >
          {mortgage ? (
            isLandMortgage && editingMortgage ? (
              <Form form={mortgageForm} layout="vertical">
                <Row gutter={12}>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="provCode"
                      label="จังหวัด"
                      rules={[{ required: true, message: "กรุณาเลือกจังหวัด" }]}
                    >
                      <Select
                        showSearch
                        placeholder="เลือกจังหวัด"
                        optionFilterProp="label"
                        options={mortgageProvinceOptions}
                        onChange={handleMortgageProvinceChange}
                        loading={!geoRawData}
                        disabled={!geoRawData}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="distCode"
                      label="อำเภอ"
                      rules={[{ required: true, message: "กรุณาเลือกอำเภอ" }]}
                    >
                      <Select
                        showSearch
                        placeholder={
                          mortgageSelectedProvince
                            ? "เลือกอำเภอ"
                            : "เลือกจังหวัดก่อน"
                        }
                        optionFilterProp="label"
                        options={mortgageDistrictOptions}
                        onChange={handleMortgageDistrictChange}
                        disabled={!mortgageSelectedProvince}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="subDistCode"
                      label="ตำบล"
                      rules={[{ required: true, message: "กรุณาเลือกตำบล" }]}
                    >
                      <Select
                        showSearch
                        placeholder={
                          mortgageSelectedDistrict
                            ? "เลือกตำบล"
                            : "เลือกอำเภอก่อน"
                        }
                        optionFilterProp="label"
                        options={mortgageSubDistrictOptions}
                        disabled={!mortgageSelectedDistrict}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="typeLandName"
                      label="ประเภทเอกสารสิทธิ์"
                      rules={[
                        {
                          required: true,
                          message: "กรุณาเลือกประเภทเอกสารสิทธิ์",
                        },
                      ]}
                    >
                      <Select
                        options={Object.keys(TYPE_LAND_ID_BY_NAME).map(
                          (name) => ({ label: name, value: name }),
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="numberLand"
                      label="เลขที่ดิน"
                      rules={[
                        { required: true, message: "กรุณากรอกเลขที่ดิน" },
                      ]}
                    >
                      <Input placeholder="เลขที่ดิน" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item name="engNo" label="เลขระวาง">
                      <Input placeholder="เลขระวาง" />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            ) : (
              <Descriptions column={2} size="small" bordered>
                {isLandMortgage ? (
                  <>
                    <Descriptions.Item label={`จังหวัด`}>
                      {displayMortgage.TYPE || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="อำเภอ">
                      {displayMortgage.MODEL || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="ตำบล">
                      {displayMortgage.BAAB || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="ประเภทเอกสารสิทธิ์">
                      {displayMortgage.COLOR || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="เลขที่ดิน">
                      {displayMortgage.STRNO || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="เลขระวาง">
                      {displayMortgage.ENGNO || "-"}
                    </Descriptions.Item>
                  </>
                ) : (
                  <>
                    <Descriptions.Item label="ประเภท">
                      {mortgage.TYPE || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="รุ่น">
                      {mortgage.MODEL || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="แบบ">
                      {mortgage.BAAB || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="สี">
                      {mortgage.COLOR || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="เลขตัวถัง">
                      {mortgage.STRNO || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="เลขเครื่อง">
                      {mortgage.ENGNO || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="ทะเบียน">
                      {mortgage.REGNO || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="ปีที่ผลิต">
                      {mortgage.MANUYR || "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="จังหวัด">
                      {mortgage.DORECV || "-"}
                    </Descriptions.Item>
                  </>
                )}
              </Descriptions>
            )
          ) : (
            <Empty description="ไม่พบข้อมูลทรัพย์ในสัญญา" />
          )}
        </Card>
        <Card
          size="small"
          title={`ทรัพย์ที่สืบออนไลน์พบ (${foundAssetRows.length} รายการ)`}
          style={{ marginBottom: 16 }}
        >
          {foundAssetRows.length > 0 ? (
            <Table
              size="small"
              dataSource={foundAssetRows}
              columns={foundAssetColumns}
              rowKey="key"
              pagination={false}
              scroll={{ x: true, y: 300 }}
            />
          ) : (
            <Empty description="ไม่พบข้อมูลทรัพย์" />
          )}
        </Card>
        {console.log("lawyerOptions", receiveBy)}
        <Card size="small" title="เลือกผู้รับผิดชอบ">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Text type="secondary">ผู้รับผิดชอบ</Text>
              <Select
                style={{ width: "100%", marginTop: 4 }}
                options={lawyerOptions}
                value={receiveBy}
                onChange={(value) => setReceiveBy(value)}
                placeholder="เลือกผู้รับผิดชอบ"
                showSearch
                allowClear
              />
            </Col>
            {/* <Col xs={24} sm={12}>
              <Text type="secondary">ระยะทาง (กม.)</Text>
              <InputNumber
                style={{ width: "100%", marginTop: 4 }}
                value={distance}
                onChange={setDistance}
                min={0}
              />
            </Col> */}
            <Col span={24}>
              <Text type="secondary">หมายเหตุ</Text>
              <Input.TextArea
                style={{ marginTop: 4 }}
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                rows={2}
              />
            </Col>
          </Row>
        </Card>
      </Spin>

      <div style={{ textAlign: "center", marginTop: 16 }}>
        <Space>
          <Button onClick={() => onClose(false)} size="large">
            ปิด
          </Button>
          <Popconfirm
            title="ยืนยันส่งบังคับคดี?"
            description="คุณต้องการส่งสัญญานี้เข้าสู่กระบวนการบังคับคดีใช่หรือไม่"
            onConfirm={handleSend}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Button
              type="primary"
              size="large"
              icon={<SendOutlined />}
              loading={submitting}
            >
              ส่งบังคับคดี
            </Button>
          </Popconfirm>
        </Space>
      </div>
    </Modal>
  );
};

export default AssignOnceLawyerModal;
